import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { imgRoot } from "../../constant/app-paths";
import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  imgFull: {
    width: "100%",
    display: "block",
  },
  link: {
    textDecoration: "none",
  },
}));

export default function Home() {
  const classes = useStyles();

  return (
    <main>
      <div className={classes.root}>
        <Grid container alignItems="stretch">
          <Grid item xs={12} md={6}>
            <div className={classes.paper}>
              <img
                className={classes.imgFull}
                src={`${imgRoot}frontDoor.jpeg`}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid
              container
              justifyContent="center"
              alignItems="stretch"
              className={classes.paper}
            >
              <Grid item>
                <div>
                  <h3>We make awesome sushi!</h3>
                  <p>Enjoy your food here!</p>
                  <Button color="primary">
                    <Link className={classes.link} to="/menu">
                      View Our Menu
                    </Link>
                  </Button>
                  <img
                    className={classes.imgFull}
                    src={`${imgRoot}sushi.png`}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className={classes.paper}>
              <img
                className={classes.imgFull}
                src={`${imgRoot}tuna.png`}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </main>
  );
}
